module.exports = __webpack_public_path__ + "static/media/guide_2.fe4e8676.svg";